const STEPS = {
  INIT: 0,
  CREATE_CAMPAIGN: 1,
  CREATE_ASSETS: 2,
  REDIRECT_TO_CAMPAIGN: 3,
  UPLOAD: 4,
  SUCCESS: 5,
};

const deliverNew = {
  state: {
    step: STEPS.INIT,
    campaign: null,
    campaignIsNew: false,
    assetActions: null,
    assets: null,
    goingBackwards: false,
  },
  reducers: {
    reset: (state) => {
      return {
        step: STEPS.INIT,
        campaign: null,
        campaignIsNew: false,
        assetActions: null,
        assets: null,
        goingBackwards: true,
      };
    },
    goBack: (state) => {
      return state.step === STEPS.CREATE_ASSETS && state.campaignIsNew
        ? {
            ...state,
            step: STEPS.CREATE_CAMPAIGN,
            goingBackwards: true,
          }
        : {
            ...state,
            step: STEPS.INIT,
            campaign: null,
            campaignIsNew: false,
            goingBackwards: true,
          };
    },
    onNoCampaign: (state) => {
      return {
        ...state,
        step: STEPS.CREATE_CAMPAIGN,
        goingBackwards: false,
      };
    },
    onCampaignCreate: (state, { campaign }) => {
      return {
        ...state,
        step: STEPS.CREATE_ASSETS,
        campaignIsNew: true,
        campaign,
        goingBackwards: false,
      };
    },
    onCampaignSelect: (state, campaign) => {
      return {
        ...state,
        step: STEPS.CREATE_ASSETS,
        campaignIsNew: false,
        campaign,
        goingBackwards: false,
      };
    },
    onCampaignRedirect: (state, campaign) => {
      return {
        ...state,
        step: STEPS.REDIRECT_TO_CAMPAIGN,
        campaignIsNew: false,
        campaign,
        goingBackwards: false,
      };
    },
    upload: (state, assetActions) => {
      return {
        ...state,
        step: STEPS.UPLOAD,
        assetActions,
        goingBackwards: false,
      };
    },
    success: (state, assets) => {
      return {
        ...state,
        step: STEPS.SUCCESS,
        assets,
        goingBackwards: false,
      };
    },
  },
};

export default deliverNew;
export { STEPS };
